import {
  SET_MAGAZINE,
  SET_MAGAZINES,
  ADD_MAGAZINE,
  EDIT_MAGAZINE,
  DELETE_MAGAZINE,
  TRANSFER_TEMPLATE_MAGAZINE,
  FILTER_MAGAZINES,
  EXPORTI_PDF,
  UPDATE_PDF_STATUS
} from '../types'
import { getFormatedDate } from '@/constants'

let initialState = {
  magazine: {},
  magazines: [],
  filter: '',
  exportingPdf: {
    exporting: false,
    content: null,
    exportedMagazines: [],
    magazineId: null
  }
}

export default function (state = initialState, action) {
  const { type, payload } = action
  switch (type) {
    case SET_MAGAZINE:
      return {
        ...state,
        magazine: payload
      }

    case SET_MAGAZINES:
      return {
        ...state,
        magazines: payload
      }

    case ADD_MAGAZINE:
      return {
        ...state,
        magazines: [payload, ...state.magazines]
      }

    case EDIT_MAGAZINE:
      const { data, id } = payload

      const magazines = state.magazines.map(magazine => (
        magazine.id === id ? { ...magazine, ...data } : magazine
      ))

      return {
        ...state,
        magazines
      }

    case DELETE_MAGAZINE:
      return {
        ...state,
        magazines: state.magazines.filter(i => +i.id !== +payload)
      }

    case TRANSFER_TEMPLATE_MAGAZINE:
      window.open(`/magazines/${payload.id}`, '_blank')
      return state

    case FILTER_MAGAZINES:
      return {
        ...state,
        filter: payload
      }

    case EXPORTI_PDF:
      return {
        ...state,
        exportingPdf: {
          ...state.exportingPdf,
          ...payload
        }
      }

    case UPDATE_PDF_STATUS:
      const _exportedMagazines = state.exportingPdf.exportedMagazines.filter(
        item => {
          return (
            getFormatedDate(item.date, true) !==
            getFormatedDate(payload.date, true)
          )
        }
      )
      state.exportingPdf.exportedMagazines = _exportedMagazines
      return {
        ...state
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/magazines.js